module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1011-eaa7183087fe4974d0aefacdafc3095a.png";